/**
 * Store: Predictive search
 * -----------------------------------------------------------------------------
 * Shares query and last viewed products.
 * - Tied to the predictive search and search bar components.
 * - Only JSDOC custom parameters, ignore module state or object.
 *
 */
import { defineStore } from 'pinia';

const usePredictiveSearchStore = defineStore('predictive-search', {
  state: () => ({
    query: '',
  }),

  actions: {
    /**
     * Commit query value.
     * @param {String} query - Search query value.
     */
    updateQuery(value) {
      this.query = value;
    },
  },
});

export default usePredictiveSearchStore;
